export function validateHash(str?: string) {
  if (!str) return false
  if (str.length < 10) return false
  return true
}
